/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import PropTypes from 'prop-types';

class FieldError extends React.Component {

    render() {
        const {errorText} = this.props;
        return (
            <div className="field-error">
                {errorText}
            </div>
        );
    }
}

FieldError.propTypes = {
    errorText: PropTypes.string
};

export default FieldError;
